import React, { Component } from 'react';

import Page500 from '../../views/Pages/Page500/';

// Captura las excepciones que lanzan los componentes hijos durante el render y
// muestra Page500 en su lugar. Sin esto, desde React 16 una excepcion no atrapada
// desmonta todo el arbol y la aplicacion queda en una pantalla en blanco.
//
// No reemplaza al manejo de errores de las vistas: las respuestas de error de la
// API ya se manejan en cada pantalla. Esto es la red de contencion para lo que no
// se previo.
class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, info) {
        // El error se sigue logueando: la pagina amigable no tiene que ocultar el
        // stack trace a quien este debugueando.
        console.error('Error no atrapado:', error, info);
        this.setState({ hasError: true });
    }

    render() {
        if (this.state.hasError) return <Page500 />;
        return this.props.children;
    }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.js